import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TareaCasoService } from 'src/app/services/tareacaso.service';

@Component({
  selector: 'app-verificacion-saime',
  templateUrl: './verificacion-saime.component.html',
  styleUrls: ['./verificacion-saime.component.scss'],
})
export class VerificacionSaimeComponent implements OnInit {
  form: FormGroup;
  @Input() data: { task: any };
  constructor(private fb: FormBuilder, public _tareacaso: TareaCasoService) {}

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      validar: [values ? values.validar : false, [Validators.required]],
    });
  }

  async validar() {
    this.form.controls.validar.setValue(true);
  }
}
